import {AbstractDataFilter} from './../filters/abstract-data-filter';
import {DataSource} from './../../data-sources/sources/abstract-data-source';
import {DataFiltersLoader} from './../loader/data-filters-loader';

export abstract class DataMerger extends AbstractDataFilter {
    public filteredData: any[];
    public hiddenData: any[];

    constructor(public source: DataSource, protected filters: AbstractDataFilter[], protected dataFiltersManager: DataFiltersLoader) {
        super();
        this.subscribeToFilters(filters);
        // at this point, mergers are always enabled.
        this.execute({enabled: true});
    }

    private subscribeToFilters(filters: AbstractDataFilter[]) {
        filters.forEach((filter) => {
            filter.filterUpdatedEvent.attach(() => {
                this.execute({enabled: true});
            }),
            filter.filterDeletedEvent.attach(() => {
                this.deleteFilter(filter);
            });
        });
    }

    public deleteFilter = (filter: AbstractDataFilter) => {
        let index = this.filters.indexOf(filter);
        this.filters.splice(index, 1);
        this.execute({enabled: true});
    }

    public addFilter(filter: AbstractDataFilter) {
        this.subscribeToFilters([filter]);
        this.filters.push(filter);
        this.execute({enabled: true});
    }
}
